import { Slot } from '@radix-ui/react-slot'

import { cn } from '~/utils/cn'
import { type VariantProps, tv } from '~/utils/tv'

type TitleProps = React.ComponentPropsWithRef<'h2'> &
  VariantProps<typeof titleVariants> & {
    asChild?: boolean
  }

const titleVariants = tv({
  base: 'font-bold font-sans leading-tiny tracking-normal no-underline',
  variants: {
    variant: {
      'large-bold': 'text-sevenpulse',
      'default-bold': 'text-sixpulse',
      'small-bold': 'text-fivepulse',
    },
  },
  defaultVariants: {
    variant: 'large-bold',
  },
})

function Title({ variant, asChild, ...props }: TitleProps) {
  const Comp = asChild ? Slot : 'h2'

  return (
    <Comp
      {...props}
      className={cn(
        titleVariants({
          variant,
        })
      )}
    />
  )
}

export { Title, type TitleProps }
